import styled, { css } from 'styled-components';
import { formLabel } from 'modules/theme';
import { themeGet } from 'modules/v2/foundation/theme';
import { responsiveProperty } from 'modules/v2/utils/responsiveProperty';
const labelInvalidStyles = css `
  color: ${themeGet('colors.text.danger')};
`;
/** @deprecated - Should be removed once the $labelSize prop is removed. */
const labelFontSize = {
    small: themeGet('fontSize.small'),
    medium: themeGet('fontSize.medium'),
    large: themeGet('fontSize.large'),
};
export const StyledLabel = styled.label `
  ${formLabel};

  transition: color 0.1s ease-in-out;

  font-size: ${(props) => labelFontSize[props.$labelSize || 'small']};
  ${(props) => props.$fontSize && responsiveProperty('fontSize', props.$fontSize)};

  &:has(+ * :disabled) {
    color: ${themeGet('colors.disabled.200')};
  }

  &:has(+ * :focus-visible) {
    color: ${(props) => !props.$invalid && themeGet('colors.primary.1000')};
  }

  ${(props) => props.$invalid && labelInvalidStyles};
`;
